import { useMutation } from "react-query";
import { createFamilyMentalHealthHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useCreateFamilyMentalHealthHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createFamilyMentalHealthHistory(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the family mental health history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    createFamilyMentalHealthHistoryMutation: mutate,
    isCreateFamilyMentalHealthHistoryLoading: isLoading,
    ...rest,
  };
};

export default useCreateFamilyMentalHealthHistory;
